import {
  Box,
  Button,
  HStack,
  Select,
  Text,
  Textarea,
  VStack,
  useToast,
} from '@chakra-ui/react';
import { ArrowLeft, Send } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import {
  createUtilityTemplate,
  submitUtilityTemplateForApproval,
} from '../../../hooks/facebook_utility_messages';

export default function FacebookNewUtilityMessagePage() {
  const { orgId, profileId } = useParams();
  const navigate = useNavigate();
  const toast = useToast();

  const [content, setContent] = useState('');
  const [trigger, setTrigger] = useState('ACCOUNT_UPDATE');
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    setLoading(true);

    const res = await createUtilityTemplate(orgId || '', profileId || '', {
      template_name: `utility_${Date.now()}`,
      language: 'en',
      body_text: content,
      category: 'UTILITY',
      trigger,
    });

    if (res.success) {
      await submitUtilityTemplateForApproval(orgId || '', profileId || '', res.data.id);
      toast({ title: 'Submitted for approval', status: 'success' });
      navigate(-1);
    } else {
      toast({ title: 'Failed to create template', status: 'error' });
    }
    setLoading(false);
  };

  return (
    <Box minH="100vh" bg="#f5f7fb" px={{ base: 4, md: 6 }} py={{ base: 6, md: 8 }}>
      <Box maxW="760px" mx="auto" bg="white" border="1px solid" borderColor="blackAlpha.100" borderRadius="28px" boxShadow="0 24px 60px rgba(15,23,32,0.06)">
        <VStack align="stretch" spacing={0}>
          <HStack px={6} py={5} justify="space-between" borderBottom="1px solid" borderColor="blackAlpha.100">
            <Button
              leftIcon={<ArrowLeft size={16} />}
              variant="ghost"
              borderRadius="14px"
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
            <Text fontWeight="700" color="gray.900">
              New Utility Message
            </Text>
          </HStack>

          <VStack px={{ base: 5, md: 6 }} py={{ base: 6, md: 7 }} spacing={5} align="stretch">
            <VStack align="stretch" spacing={2}>
              <Text fontSize="sm" fontWeight="600" color="gray.800">
                Message body
              </Text>
              <Textarea
                placeholder="Example: Your order has shipped and should arrive tomorrow."
                minH="140px"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                borderRadius="18px"
              />
            </VStack>

            <VStack align="stretch" spacing={2}>
              <Text fontSize="sm" fontWeight="600" color="gray.800">
                Trigger
              </Text>
              <Select
                value={trigger}
                onChange={(e) => setTrigger(e.target.value)}
                borderRadius="16px"
                h="48px"
              >
                <option value="ACCOUNT_UPDATE">Account update</option>
                <option value="POST_PURCHASE_UPDATE">Post-purchase update</option>
                <option value="CONFIRMED_EVENT_UPDATE">Confirmed event update</option>
              </Select>
            </VStack>

            <Box bg="#f8fafc" border="1px solid" borderColor="blackAlpha.100" borderRadius="18px" px={4} py={4}>
              <Text fontSize="sm" color="gray.600" lineHeight="1.7">
                Utility messages are used when free text is not available. Keep the message specific, operational, and aligned with Meta policy.
              </Text>
            </Box>

            <Button
              leftIcon={<Send size={16} />}
              bg="#1877F2"
              color="white"
              _hover={{ bg: '#1667d9' }}
              isLoading={loading}
              onClick={handleCreate}
              borderRadius="16px"
              isDisabled={!content.trim()}
            >
              Submit for approval
            </Button>
          </VStack>
        </VStack>
      </Box>
    </Box>
  );
}
